var initSizeClasses = require('./lib/size-classes.js');
var VermontPreloader = require('./components/preloader.js');

initSizeClasses();
new VermontPreloader();
